export const GptRequestStatuses = {
  Created: 'created',
  Processing: 'processing',
  Received: 'received',
  Completed: 'completed',
  Published: 'published',
  Retrying: 'retrying',
  Cancelled: 'canceled',
  Deleted: 'deleted',
  NoQuestionsContent: 'no_questions_content',
  NoDocumentsContent: 'no_documents_content',
  Failed: 'failed',
  DocumentSizeTooLarge: 'document_size_too_large'
};

export const FailedGptRequestStatuses = [
  GptRequestStatuses.Failed,
  GptRequestStatuses.NoQuestionsContent,
  GptRequestStatuses.NoDocumentsContent,
  GptRequestStatuses.DocumentSizeTooLarge
];
